import { Reducer } from 'redux';

import { UserFilesState } from './types';

const defaultState = {
    loading: false,
};

const reducer: Reducer<UserFilesState> = (state = defaultState, action): UserFilesState => {
    const { payload, type } = action;

    switch (type) {
        case '@@userFiles/DELETE_FILE_SUCCESS':
        case '@@userFiles/DELETE_FILES_LIST_SUCCESS':
        case '@@userFiles/LOADING_FILES_SUCCESS':
            return {
                loading: false,
                files: payload.files,
            };
        case '@@userFiles/LOADING_FILES_ERROR':
            return {
                loading: false,
            };
        case '@@userFiles/LOAD_USER_FILES':
            return {
                loading: true,
            };
        case '@@userFiles/DELETE_FILE':
        case '@@userFiles/DELETE_FILES_LIST':
        case '@@userFiles/DELETE_FILE_ERROR':
        case '@@userFiles/DELETE_FILES_LIST_ERROR':
        case '@@userFiles/DELETE_FILE_START':
        case '@@userFiles/DELETE_FILES_LIST_START':
        case '@@userFiles/START_LOADING_FILES':
        default:
            return state;
    }
};

export { reducer as userFiles };

export default reducer;
